module.exports = __webpack_public_path__ + "img/logo_kompascom.05b9432b.png";